module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/442.8a700f84.png";